import Connector from 'connect-store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import IControl = mapboxgl.IControl;
import RegionInfoView from '../../views/RegionInfoView/RegionInfoView';
// import {SelectRegion, ShowRegionInfo} from '../../views/RegionListView';
// import LayerPanelView from '../../views/layerPanelView/LayerPanelView'
import regionStore from "../../storeInstances/regionStore";
// const layer = require('../../views/layerPanelView/LayerPanelView');
// const regionStore  = layer.regionStore;
export default class RegionListControl implements IControl {
  private _container: HTMLDivElement = document.createElement('div');

  public onAdd() {
    ReactDOM.render(
      <Connector store={ regionStore } View={RegionInfoView}/>,
      this._container,
    );
    return this._container;
  }

  public onRemove() {
    this._container.parentNode!.removeChild(this._container);
  }

  public getDefaultPosition() {
    return 'top-left';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/controls/RegionInfoControl.tsx